import type { Factory } from 'walden-fast/types/mocks';
import type { Transaction } from 'walden-fast/types/transaction';

export const MOCK_TRANSACTION: Transaction = {
  quantity: 20,
  status: 'success',
  type: 'IN',
  date: new Date(1732721945000),
};

export const transactionFactory: Factory<Transaction> = (overrides) => ({
  ...MOCK_TRANSACTION,
  quantity: Math.floor(Math.random() * 100),
  status: ['success', 'failed'][Math.floor(Math.random() * 2)] as string,
  type: ['IN', 'OUT'][Math.floor(Math.random() * 2)] as string,
  date: new Date(1733750902000 + (Math.random() - 0.5) * 1000000000),
  ...overrides,
});
